import { createUseStyles } from 'react-jss'
import { zIndexes } from '../../variables.style'

export const style = {
  container: {
    display: 'flex',
    width: '100%',
    position: 'relative',
    zIndex: ({ dropdownOpen }) => dropdownOpen ? zIndexes.sideBySideChartLeft + 1 : zIndexes.sideBySideChartFilterBar
  }
}

export const useStyles = createUseStyles(style)
